import { TextMessageSidebarHeader } from "@/core/components/text-message-sidebar-header";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";
import { useBusinessSettingsSidebar } from "@/business-settings/context/business-settings-sidebar-context";
import { useGetTextMessage } from "@/text-messages/query";
import TextMessagesSidebar from "@/text-messages/text-messages-sidebar";
import { TextMessagesSidebarSkeleton } from "./text-messages-sidebar-skeleton";

interface BusinessSettingsTextMessagesSidebarProps {
  textMessageId: string;
  businessId: string;
  isOpen: boolean;
}

const BusinessSettingsTextMessagesSidebar = ({
  textMessageId,
  businessId,
  isOpen,
}: BusinessSettingsTextMessagesSidebarProps) => {
  const { resetSidebar } = useBusinessSettingsSidebar();

  const { data: textMessage, isLoading } = useGetTextMessage(
    businessId,
    textMessageId,
  );

  if (isLoading) {
    return <TextMessagesSidebarSkeleton />;
  }

  if (!textMessage) {
    return (
      <BusinessSettingsSidebarWrapper>
        <div className="p-5">Message not found.</div>
      </BusinessSettingsSidebarWrapper>
    );
  }

  return (
    <BusinessSettingsSidebarWrapper>
      <TextMessageSidebarHeader
        selectedItem={textMessage}
        setIsSidebarOpen={resetSidebar}
      />
      <div className="flex-1 overflow-hidden">
        <TextMessagesSidebar textMessage={textMessage} isOpen={isOpen} />
      </div>
    </BusinessSettingsSidebarWrapper>
  );
};

export default BusinessSettingsTextMessagesSidebar;
